module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "210px",
      "color": "#c70000",
      "font-weight": "100"
    }
  }, [_vm._v("Ops...")]), _vm._v(" "), _c('h3', [_vm._v("Faça seu cadastro ou entre para ver detalhes do produto.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44954a51","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/404.vue
// module id = 871
// module chunks = 0